import React from "react";
import {
    Sidebar,
    Menu,
    SubMenu,
    MenuItem,
    sidebarClasses,
} from "react-pro-sidebar";
import logo909 from "../assets/icons/909.png";
import logoLC7 from "../assets/icons/LC7.png";
import logo777 from "../assets/icons/777.png";
import logoMoneyBall from "../assets/icons/moneyBall.png";
import logodefault from "../assets/icons/adminHub.png";
import logoEP from "../assets/icons/epsport.png";
import { Link, useLocation } from "react-router-dom";
import {
    FaTachometerAlt, FaCheck, FaCheckDouble, FaExchangeAlt, FaFutbol, FaChartBar,
    FaBan, FaUser, FaFileAlt, FaUserShield, FaPlus, FaTasks, FaUserClock, FaCalendarAlt, FaChartLine, FaAlignJustify, FaUsers ,
    FaEdit, FaTools, FaLaptop, FaDollarSign, FaBuffer, FaCheckCircle, FaClipboardCheck, FaClipboard, FaClipboardList, FaDesktop, FaShieldAlt,
    FaCodeBranch,FaClock,FaHourglassEnd          
} from "react-icons/fa";
import { MdMonitorHeart  , MdHub } from "react-icons/md";
import { FaGear } from "react-icons/fa6";
import { AiFillDollarCircle } from "react-icons/ai";

function ModernSidebar({ open, setOpen,darkMode }) {
    const location = useLocation();

    const info = JSON.parse(sessionStorage.getItem("userDetails"));

    const invalidItem = companyPolicies[info?.companyId]?.hideSections || [];

    const invalidSubMenu = companyPolicies[info?.companyId]?.hideItems || [];

    const navigation = [
        { name: "Dashboard", route: "/dashboard", icon: <FaTachometerAlt /> },
         { name: "Match Event", route: "/match-event", icon: <FaExchangeAlt /> },
        {
            name: "Odds",
            route: "/odds-hub",
            icon: <MdMonitorHeart/>,
            subMenu: [
                { name: "Odds Hub", route: "/odds-hub", icon: <MdHub /> },
                { name: "Check Odd", route: "/check-odd", icon: <FaCheck /> },
                //{ name: "Different Odd", route: "/diff-odd", icon: <FaTasks /> },
            ],
        },
        {
            name: "Result",
            route: "/goal-result",
            icon: <FaFutbol />,
            subMenu: [
                { name: "Result Hub", route: "/result-hub", icon: <MdHub  /> },
                { name: "Insert Result", route: "/insert-result", icon: <FaPlus /> },
                { name: "Recalculation", route: "/update-result", icon: <FaEdit /> }
            ],
        },
        {
            name: "Reports",
            route: "/diff-odd-vouchers",
            icon: <FaFileAlt />,
            subMenu: [
                { name: "Win/Lose", route: "/win-lose", icon: <FaChartBar  /> },
                { name: "Event Risk", route: "/report-byevent", icon: <FaClipboard  /> },
                { name: "Mix Exposure", route: "/report-bymix", icon: <FaClipboardList  /> },
                //{ name: "By User", route: "#", icon: <FaUser /> },
                { name: "Hedge/Purchase", route: "/report-bypurchased", icon: <FaClipboardCheck  /> },
                //{ name: "By Reject", route: "#", icon: <FaBan /> }
            ],
        },
        {
            name: "Transaction",
            icon: <FaClock   />,
            subMenu: [
                { name: "User Transaction", route: "/transaction-bydate", icon: <FaCalendarAlt /> },
                { name: "Balance Transaction", route: "/balance-transfer", icon: <FaDollarSign /> }
            ],
        },
        {
            name: "User Hub",
            icon: <FaUser  />,
            subMenu: [
                { name: "User Control", route: "/user-control", icon: <FaUsers   /> }
            ],
        },
        {
            name: "Betting Hub",
            icon: <AiFillDollarCircle />,
            subMenu: [
                //{ name: "By Voucher", route: "/by-voucher", icon: <FaFileAlt /> },    
                { name: "Outstanding", route: "/live-betting-control", icon: <FaHourglassEnd   /> },
                { name: "Limit", route: "/gambling-limit", icon: <FaBan /> },
                { name: "Voucher Explorer", route: "/voucher-explorer", icon: <FaClipboardList /> }
            ],
        },
        {
            name: "Selection Hub",
            icon: <FaShieldAlt  />,
            subMenu: [
                { name: "League Selection", route: "/league-selection", icon: <FaCheckCircle   /> },
                { name: "Buffer Zone", route: "/buffer-zone", icon: <FaBuffer /> },
                { name: "Event Control", route: "/live-event-control", icon: <FaLaptop /> }
            ],
        },
        info?.role === "super-admin" &&
        {
            name: "Settings",
            icon: <FaGear   />,
            route: "/settings"
        }
    ];

    const menuItemStyles = {
        root: {
            fontSize: "14px",
            fontWeight: 500,
        },
        icon: {
            color: "#fff",
        },
        subMenuContent: ({ level }) => ({
            backgroundColor: level === 0 ? darkMode ? "#2C2E4A" : "#2c2f4c" : "transparent",
        }),
        button: {
            fontSize: "14px",
            "&:hover": {
                backgroundColor: "#2c2f4c",
                color: "#ECF0F3",
            },
        },
        label: ({ level, open }) => ({
            fontSize: "14px",
            fontWeight: 500,
            marginLeft: 0
        }),
    };

    return (
        <Sidebar
            collapsed={!open}
            backgroundColor={ darkMode ? "#1B263B" : "#292E4C"}
            transitionDuration={500}
            rootStyles={{
                height: "100vh",
                // position: "fixed",
                // top: 0,
                // left: 0,
                color: "#fff",
                [`.${sidebarClasses.container}::-webkit-scrollbar`]: {
                    display: "none",
                },
            }}
            className="no-scrollbar hidden md:block"
        >
            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <div style={{ flex: 1 }}>
                    <div className={`flex justify-center items-center my-2 mx-2`}>
                        <img
                            src={logoMapping[info?.companyId] || logodefault}
                            className={widthMapping[info?.companyId] || "w-[80px] bg-customFontMilkWhite rounded-xl p-1"}
                            alt="logo"
                        />
                    </div>
                    {/* {!open && <div className="text-center mt-2 text-sm">ADMIN</div>}
                    {open && <div className="text-center my-4 text-md">ADMIN PANEL</div>} */}
                    <Menu menuItemStyles={menuItemStyles}>
                        {navigation.filter(a => !invalidItem.includes(a.name)).map((item, i) => (
                            <React.Fragment key={i}>
                                {item.subMenu ? (
                                    <SubMenu label={item.name} icon={item.icon} title={!open ? item.name : undefined}>
                                        {item.subMenu.filter(a => !invalidSubMenu.includes(a.name)).map((el) => (
                                            <MenuItem key={el.route} icon={el.icon}>
                                                <Link
                                                    to={el.route}
                                                    className={`${location.pathname === el.route
                                                        ? "bg-background/[0.5]"
                                                        : ""
                                                        } rounded-md px-3 py-2 font-semibold text-sm w-full h-full flex text-gray-300 hover:text-white`}
                                                >
                                                    {el.name}
                                                </Link>
                                            </MenuItem>
                                        ))}
                                    </SubMenu>
                                ) : (
                                    <MenuItem
                                        key={item.route}
                                        icon={item.icon}
                                        title={!open ? item.name : undefined}
                                        component={<Link to={item.route} />}
                                    >
                                        {item.name}
                                    </MenuItem>
                                )}
                            </React.Fragment>
                        ))}
                    </Menu>
                </div>
            </div>
        </Sidebar>
    );
}

export default ModernSidebar;

const logoMapping = {
    "909": logo909,
    "LC7": logoLC7,
    "MNB": logoMoneyBall,
    "777": logo777,
    "EP" : logoEP
}

const widthMapping = {
    "909": "w-[75px]",
    "LC7": "w-[75px]",
    "MNB": "w-[85px]",
    "777": "w-[60px]",
    "EP" : "w-[75px]"
}

const companyPolicies = {
  "LC7": {
    hideSections: ["Different Odd", "Match Event", "Check Odd","Selection Control","Odds"],
    hideItems: ["Result Hub"]
  },
  "909": {
    hideSections: [],
    hideItems: [],
  },
  "MNB" : {
    hideSections: ["Different Odd", "Match Event", "Check Odd", "Selection Control","Odds"],
    hideItems: ["Result Hub"]
  },
   "777" : {
    hideSections: ["Different Odd", "Match Event", "Check Odd", "Selection Control","Odds"],
    hideItems: ["Result Hub"]
  },
  "EP" : {
    hideSections: ["Different Odd", "Match Event", "Check Odd", "Selection Control","Odds"],
    hideItems: ["Result Hub","Balance Transaction"]
  }
};
